import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class MydbService {

  constructor(private myStorage: Storage) { }

  keys = {
    login: "login",
    userdata: "userdata"
  }

  timeAPI = new Date();

  setStorage(key, val) {
    return this.myStorage.set(key, val);
  }

  getStorage(key) {
    return this.myStorage.get(key);
  }

  clearStorage() {
    return this.myStorage.clear();
  }

}
